// extracted by mini-css-extract-plugin
module.exports =  {"button":"_93444fe79c--button--pv5jF","dark":"_93444fe79c--dark--SHfpm"};